import { useState, createContext, useEffect } from "react";

export const UserInfo = createContext();

const UserInfoProvider = (props) => {

  //Data Route Vars

  const [Recent, setRecent] = useState(() => {
    const localData = localStorage.getItem("Recent");
    return localData ? JSON.parse(localData) : "<1Año";
  });

  const [LoggedIn, setLoggedIn] = useState(() => {
    const localData = localStorage.getItem("LoggedIn");
    return localData ? JSON.parse(localData) : false;
  });

  const [LoggedOut, setLoggedOut] = useState(() => {
    const localData = localStorage.getItem("LoggedOut");
    return localData ? JSON.parse(localData) : false;
  });

  const [SessionExpired, setSessionExpired] = useState(() => {
    const localData = localStorage.getItem("SessionExpired");
    return localData ? JSON.parse(localData) : false;
  });

  useEffect(() => {
    localStorage.setItem("Recent", JSON.stringify(Recent));
  }, [Recent]);

  useEffect(() => {
    localStorage.setItem("LoggedIn", JSON.stringify(LoggedIn));
  }, [LoggedIn]);

  useEffect(() => {
    localStorage.setItem("LoggedOut", JSON.stringify(LoggedOut));
  }, [LoggedOut]);

  useEffect(() => {
    localStorage.setItem("SessionExpired", JSON.stringify(SessionExpired));
  }, [SessionExpired]);


  //Medical Route Vars

  const [MedHis, setMedHis] = useState(() => {
    const localData = localStorage.getItem("MedHis");
    return localData ? JSON.parse(localData) : []
  });

  useEffect(() => {
    localStorage.setItem("MedHis", JSON.stringify(MedHis));
  }, [MedHis]);

  const [FamilyMedHis, setFamilyMedHis] = useState(() => {
    const localData = localStorage.getItem("FamilyMedHis");
    return localData ? JSON.parse(localData) : []
  });

  useEffect(() => {
    localStorage.setItem("FamilyMedHis", JSON.stringify(FamilyMedHis));
  }, [FamilyMedHis]);

    return (
        <UserInfo.Provider
          value={{

  //Medical Route Vars
  MedHis, setMedHis, 
  //Family Route Vars
  FamilyMedHis, setFamilyMedHis,

  LoggedIn, setLoggedIn, LoggedOut, setLoggedOut, SessionExpired, setSessionExpired,
  Recent, setRecent
          }}>
          {props.children}
        </UserInfo.Provider>
      );
    };
    export default UserInfoProvider;